import * as React from "react";
import Seo from "../components/global/Seo";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import Hero from "../components/sections/Hero";
import AboutUs from "../components/sections/AboutUs";
import Services from "../components/sections/Services";
import Cta from "../components/sections/Cta";
import Contact from "../components/sections/Contact";

const IndexPage = () => {
  return (
    <React.Fragment>
      <Seo title="Skup elektroniki Gdańsk, Gdynia, Pomorskie" />
      <Header />
      <Hero />
      <AboutUs />
      <Services />
      <Cta />
      <Contact />
      <Footer />
    </React.Fragment>
  );
};

export default IndexPage;
